import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { apiService } from '../../service/api.service';
import { ResponseJardinModel, JardinModel} from '../../model/Jardin.model'
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ModalCambiarPassComponent } from '../jardin/components/dialogs/modal-cambiar-pass/modal-cambiar-pass.component'
import { StorageService } from 'src/app/service/storage.service';
import { EncargadaModel, ResponseEncargadaModel } from 'src/app/model/Identificacion.model';
import { ModalCambiarFotoperfilComponent } from '../jardin/components/dialogs/modal-cambiar-fotoperfil/modal-cambiar-fotoperfil.component';


@Component({
  selector: 'app-equipo-pedagogico',
  templateUrl: './equipo-pedagogico.component.html',
  styleUrls: ['./equipo-pedagogico.component.css']
})
export class EquipoPedagogicoComponent implements OnInit {
  idUsuario='';
  datosPP : any;
  menuMostrar : string;
  jardin = new JardinModel(); 
  direccionar : Subscription;
  cargando = true;
  urlProfile = '';
  constructor(  
    public api: apiService, 
    public dialog: MatDialog,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.direccionar = this.api.getEmitDireccionamiento().subscribe((respuesta:string)=>{
      this.menuVisible(respuesta)
    });
    this.idUsuario = this.storageService.getCurrentUser().idUsuario.toString();
    this.getFotoPerfil();
    this.getJardin(this.idUsuario);
    this.getPersonaEquipo(this.idUsuario);
    this.menuMostrar = this.storageService.getMenuActivo() != null ? this.storageService.getMenuActivo() : 'inicio' ;
    // src="../../../assets/avatar.png"
  }

  ngOnDestroy(): void {
    this.direccionar.unsubscribe();
  }

  getJardin(id) {

      this.api.API_POST_obtenerJardinEquipo(id).subscribe((response:ResponseJardinModel) => {
        this.api.dataJardin = response.payload;
        this.jardin = response.payload;
        
      },
      (err) => { 
        console.log(err)
      })
    
    
}

getPersonaEquipo(id){
  this.api.API_POST_getPersonaEquipo(id).subscribe((response: any) => {
    this.datosPP = response.payload;
    this.cargando = false;
  },
  (err) => {
    console.log(err)
  })
}


getFotoPerfil() {
  this.api.API_POST_obtenerFotoPerfil(this.idUsuario).subscribe((response:any) => {
    if(response.payload != null){
      this.urlProfile = "data:image/jpg;base64,"+response.payload;
    }else{
      this.urlProfile = "../../../assets/JUNJI_avatar.svg";
    }
    
  },
  (err) => { 
    this.urlProfile = "../../../assets/JUNJI_avatar.svg";
    console.log(err)
  })
}

  menuVisible(item) {
    this.storageService.setMenuActivo(item);
    this.menuMostrar = this.storageService.getMenuActivo();
  }

  cambiarPass(){ 
    const dialogRef = this.dialog.open(ModalCambiarPassComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => { 
      if(result=='refresh'){
      
      }
    });
  }

  cambiarFoto(){
    const dialogRef = this.dialog.open(ModalCambiarFotoperfilComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  

  cerrarSesion(){
    this.storageService.logout();
  }
}
